import PropTypes from 'prop-types';
import FormattedName from 'I18n/components/FormattedName';
// @ts-expect-error RecordPropType is not typed
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import { getEmail, getFirstName, getLastName } from 'conversations-message-history/senders/operators/getters';
import { UnknownSenderText } from 'conversations-message-history/senders/components/UnknownSenderText';
import { jsx as _jsx } from "react/jsx-runtime";
const FriendlySenderName = ({
  sender,
  isLoading
}) => {
  if (isLoading) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      "data-test-id": "skeleton-text",
      width: 100
    });
  }
  const givenName = sender && getFirstName(sender);
  const familyName = sender && getLastName(sender);
  const email = sender && getEmail(sender);
  const hasKnownName = Boolean(givenName || familyName || email);
  return hasKnownName ? /*#__PURE__*/_jsx(FormattedName, {
    givenName: givenName || undefined,
    familyName: familyName || undefined,
    email: email || undefined
  }) : /*#__PURE__*/_jsx(UnknownSenderText, {
    sender: sender
  });
};
FriendlySenderName.displayName = 'SenderName';
FriendlySenderName.propTypes = {
  isLoading: PropTypes.bool,
  sender: RecordPropType('Sender')
};
export default FriendlySenderName;